<script>

import Layout from '../../layouts/main'

import CouponAdd from './coupon-add'

/**
 * Promo-code component
 */
export default {
  components: { Layout, CouponAdd },
  data() {
    return {};
  }
}
</script>

<template>
<Layout>
  <coupon-add/>
</Layout>
</template>
